import { Fragment } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import bg from "../../assets/image/06.jpg";
import blog1 from "../../assets/image/blog_1.jpg";
import blog2 from "../../assets/image/blog_2.jpg";
import blog3 from "../../assets/image/blog_4.jpg";
import blog4 from "../../assets/image/course_1.jpg";
import blog5 from "../../assets/image/course_2.jpg";
import blog6 from "../../assets/image/course_3.jpg";
import BreadBanner from "../../component/BreadBanner";
import { Link } from "react-router-dom";

const Blog = () => {
  return (
    <Fragment>
      <BreadBanner bg={bg} title={"Blogs"} span={"Latest Blogs "} />
      <div className="blog">
        <div className="container">
          <div className="row">
            <div className="blog_post trans_200 col-lg-4 col-md-6 col-12">
              <div className="blog_post_image">
                <img src={blog1} alt="" />
              </div>
              <div className="blog_post_body">
                <div className="blog_post_title">
                  <Link to={"/blogItem"}>
                    Here’s What You Need to Know About Online Testing
                  </Link>
                </div>
                <div className="blog_post_meta">
                  <ul>
                    <li>
                      <a href="#">admin</a>
                    </li>
                    <li>
                      <a href="#">november 11, 2017</a>
                    </li>
                  </ul>
                </div>
                <div className="blog_post_text">
                  <p>
                    Policy analysts generally agree on a need for reform, but
                    not on which path policymakers should take...
                  </p>
                </div>
              </div>
            </div>

            <div className="blog_post trans_200 col-lg-4 col-md-6 m-auto col-12 d-flex justify-content-center flex-column">
              <div className="blog_post_body ">
                <div className="blog_post_title">
                  <Link to={"/blogItem"}>With Changing Students and Times</Link>
                </div>
                <div className="blog_post_meta">
                  <ul>
                    <li>
                      <a href="#">admin</a>
                    </li>
                    <li>
                      <a href="#">november 11, 2017</a>
                    </li>
                  </ul>
                </div>
                <div className="blog_post_text">
                  <p>
                    Policy analysts generally agree on a need for reform, but
                    not on which path policymakers should take...
                  </p>
                </div>
              </div>
            </div>

            <div className="blog_post trans_200 col-lg-4 col-md-6 col-12">
              <div className="blog_post_video_container">
                <div className="blog_post_image">
                  <img src={blog2} alt="" />
                </div>
              </div>
              <div className="blog_post_body">
                <div className="blog_post_title">
                  <Link to={"/blogItem"}>
                    Building Skills Outside the Classroom With New Ways
                  </Link>
                </div>
                <div className="blog_post_meta">
                  <ul>
                    <li>
                      <a href="#">admin</a>
                    </li>
                    <li>
                      <a href="#">november 11, 2017</a>
                    </li>
                  </ul>
                </div>
                <div className="blog_post_text">
                  <p>
                    Policy analysts generally agree on a need for reform, but
                    not on which path policymakers should take...
                  </p>
                </div>
              </div>
            </div>

            <div className="blog_post trans_200 col-lg-4 col-md-6 col-12">
              <div className="blog_post_image">
                <img src={blog3} alt="" />
              </div>
              <div className="blog_post_body">
                <div className="blog_post_title">
                  <Link to={"/blogItem"}>
                    Law Schools Debate a Contentious Testing Alternative
                  </Link>
                </div>
                <div className="blog_post_meta">
                  <ul>
                    <li>
                      <a href="#">admin</a>
                    </li>
                    <li>
                      <a href="#">november 11, 2017</a>
                    </li>
                  </ul>
                </div>
                <div className="blog_post_text">
                  <p>
                    Policy analysts generally agree on a need for reform, but
                    not on which path policymakers should take...
                  </p>
                </div>
              </div>
            </div>

            <div className="blog_post trans_200 col-lg-4 col-md-6 col-12">
              <div className="blog_post_video_container">
                <div className="blog_post_image">
                  <img src={blog4} alt="" />
                </div>
              </div>
              <div className="blog_post_body">
                <div className="blog_post_title">
                  <Link to={"/blogItem"}>
                    Building Skills Outside the Classroom With New Ways
                  </Link>
                </div>
                <div className="blog_post_meta">
                  <ul>
                    <li>
                      <a href="#">admin</a>
                    </li>
                    <li>
                      <a href="#">november 11, 2017</a>
                    </li>
                  </ul>
                </div>
                <div className="blog_post_text">
                  <p>
                    Policy analysts generally agree on a need for reform, but
                    not on which path policymakers should take...
                  </p>
                </div>
              </div>
            </div>

            <div className="blog_post trans_200 col-lg-4 col-md-6 col-12">
              <div className="blog_post_image">
                <img src={blog5} alt="" />
              </div>
              <div className="blog_post_body">
                <div className="blog_post_title">
                  <Link to={"/blogItem"}>
                    Here’s What You Need to Know About Online Testing
                  </Link>
                </div>
                <div className="blog_post_meta">
                  <ul>
                    <li>
                      <a href="#">admin</a>
                    </li>
                    <li>
                      <a href="#">november 11, 2017</a>
                    </li>
                  </ul>
                </div>
                <div className="blog_post_text">
                  <p>
                    Policy analysts generally agree on a need for reform, but
                    not on which path policymakers should take...
                  </p>
                </div>
              </div>
            </div>

            <div className="blog_post trans_200 mx-auto col-lg-4 col-md-6 col-12 d-flex justify-content-center flex-column">
              <div className="blog_post_body">
                <div className="blog_post_title">
                  <Link to={"/blogItem"}>With Changing Students and Times</Link>
                </div>
                <div className="blog_post_meta">
                  <ul>
                    <li>
                      <a href="#">admin</a>
                    </li>
                    <li>
                      <a href="#">november 11, 2017</a>
                    </li>
                  </ul>
                </div>
                <div className="blog_post_text">
                  <p>
                    Policy analysts generally agree on a need for reform, but
                    not on which path policymakers should take...
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col text-center">
              <div className="load_more trans_200">
                <a href="#">load more</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Blog;
